import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, withLatestFrom, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import {
  ListRecordLabelArtistsSuccess,
  SetActiveLabel,
} from '../action-creators';
import { LIST_RECORD_LABEL_ARTIST_SUCCESS } from '../actions';
import AppState from '../../state';
import { NoOp } from '../../ui/action-creators';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';
import { SetActiveArtist } from '../../artist/action-creators';

export const setActiveEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, ListRecordLabelArtistsSuccess | SetActiveArtist>(
      LIST_RECORD_LABEL_ARTIST_SUCCESS,
      SET_ACTIVE_ARTIST
    ),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.recordLabels.list?.length),
    map(([_, state]) => {
      if (state.artist.active?.id) {
        const labelId = Object.keys(state.recordLabels.artists).find((key) => {
          return state.recordLabels.artists[key].some(
            (a) => a.artistId === state.artist.active?.id
          );
        });

        const label = state.recordLabels.list.find((a) => a.id === labelId);

        if (!label) {
          // label = state.recordLabels.list[0];
          return new NoOp();
        }
        return new SetActiveLabel(label);
      }
      return new NoOp();
    })
  );
